<template>
  <el-header :height="height">
    <img src="@/assets/logo.png" class="logo" />
    <h1>Marketing One&#8209;to&#8209;One - E&#8209;Learning</h1>
    <p class="body" v-if="email" @click="logout">{{email}}</p>
  </el-header>
</template>

<script>
  import {LOGOUT} from '@/store/api'
import { mapGetters } from 'vuex'
export default {
  name: 'Header',
  props: {
    height: {
      type: String,
      required: true,
    }
  },
  computed: {
    ...mapGetters({
      email: 'user/email'
    })
  },
  methods: {
    logout () {
      this.$apollo.mutate({
        mutation: LOGOUT,
      })
      .then (() => {
        this.$store.commit('user/reset')
        this.$store.commit('modules/reset')
        this.$router.push({name: 'login'})
       
      })
      .catch(() => {
        this.$store.commit('user/reset')
        this.$store.commit('modules/reset')
        this.$router.push({name: 'login'})
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/styles';

  header {
    border-bottom: 1px solid #E0DFDF;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 19px 40px 17px 48px;
    color: $primary;
    img {
      height: 61px;
    }
    h1 {
      font-size: 24px;
      margin-left: 50px;
      font-weight: 400;
    }
    p {
      margin-right: 0;
      margin-left: auto;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
    @media (max-width: 800px) {
      padding-left: 20px;
      padding-right: 20px;
      h1 {
        font-size: 20px;
      }
      img {
        height: 54px;
      }
    }
    @media (max-width: 700px) {
      h1 {
        font-size: 14px
      }
    }
    @media (max-width: 600px) {
      p {
        display: none;
      }
      h1 {
        margin-righ: 0;
        margin-left: auto;
      }
    }
    @media (max-width: 414px) {
      padding: 10px;
      img {
        height: 40px;
      }
      h1 {
        word-break: break-word;
      }
    }
    @media (max-width: 320px) {
      h1 {
        font-size: 12px;
      }
    }
  }

</style>